import organizations from './organizations'

const advisor = {
  organizations,
}

export default advisor
